import { TooltipFocusableTrigger } from "@zapier/design-system";
import { ReactNode } from "react";

// This wrapper component allows for a non-focusable trigger to be used in place of a button, e.g. a disabled button.
// If we wrapped focusable elements in a Tooltip.FocusableTrigger, we end up with nested focusable
// elements and a wonky tab (extra elements) and screenreader behavior (hidden elements).

interface ButtonWrapperProps {
  isDisabled?: boolean;
  children: ReactNode;
}

const ButtonWrapper = ({ isDisabled, children }: ButtonWrapperProps) =>
  isDisabled ? (
    <TooltipFocusableTrigger>{children}</TooltipFocusableTrigger>
  ) : (
    children
  );
export default ButtonWrapper;
